import script from "./notInARoom.vue?vue&type=script&setup=true&lang=js"
export * from "./notInARoom.vue?vue&type=script&setup=true&lang=js"

import "./notInARoom.vue?vue&type=style&index=0&id=46ad7560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ad7560"]])

export default __exports__